﻿import axios from 'axios';

interface DefaultCartSummaryModel {
    totalItemsQuantity: number;
}

async function getCartSummary(cartCode?: string): Promise<number | null> {
    try {
        const response = await axios.get<DefaultCartSummaryModel>(`/api/store/cart/summary`, {
            params: { cartCode }
        });

        const cartSummary = response.data;
        return cartSummary.totalItemsQuantity;
    } catch (error) {
        console.error('Error fetching cart summary');
        return null;
    }
}

document.addEventListener('DOMContentLoaded', async () => {
    const totalItemsQuantity = await getCartSummary() || 0; // Default to 0 if there's an error with the API
    const cartItemNumberSpans = document.getElementsByClassName('item-shopping-cart');
    if (totalItemsQuantity !== null && cartItemNumberSpans.length > 0) {
        for (let i = 0; i < cartItemNumberSpans.length; i++) {
            cartItemNumberSpans[i].textContent = totalItemsQuantity.toString();
        }
    }
});
